import { SUM, PMT } from '__jsLibs/EXCEL';

const gettersPMI = {
	PMIExpense(state, getters) {
		/* if (
			getters.LoanAmount
			&& getters.LoanAmount !== 0
			&& getters.ofPayments
			&& getters.ofPayments !== 0
			&& state.result['interest_rate']
			&& state.result['interest_rate'] !== ''
			&& state.result['pmi_expense']
			&& state.result['pmi_expense'] !== ''
		) {
			return +PMT(
				(+state.result['interest_rate'] + +state.result['pmi_expense']) / (12 * 100),
				getters.ofPayments,
				getters.LoanAmount
			) * -1 - +PMT(
				state.result['interest_rate'] / (12 * 100),
				getters.ofPayments,
				getters.LoanAmount
			) * -1;
		} */
		if (
			getters.LoanAmount
			&& getters.LoanAmount !== 0
			&& state.result['pmi_expense']
			&& state.result['pmi_expense'] !== ''
		) {
			return +state.result['pmi_expense'] / 100 * +getters.LoanAmount / 12;
		}
		return 0;
	},
	MonthlyPaymentWPMI(state, getters) {
		return SUM([
			+getters.PMIExpense,
			+getters.MonthlyPaymentWOPMI
		]);
	}
};

export { gettersPMI };
